module.exports = __webpack_public_path__ + "static/20230619_044-d1521b69fc4676ba7aa858b1a144687c.jpg";